import React from "react";
import { Stack } from "digiwash-components";
import CategoriesItem from "../../components/CategoriesItem";
import {
  suggestResponsiveBoxRatioForCategories,
  suggestResponsiveColumnForCategories,
} from "../../helpers/general";

function Categories(props) {
  return (
    <Stack
      distribution="space-between"
      columns={suggestResponsiveColumnForCategories(
        suggestResponsiveBoxRatioForCategories().column
      )}
      fillIfEmpty
    >
      {props.data &&
        props.data.map((item, index) => {
          return (
            <CategoriesItem
              key={item.id}
              title={item.name}
              id={item.id}
              icon={item.alias}
              index={index}
            />
          );
        })}
    </Stack>
  );
}

export default Categories;
